/**
 * @file _initialize/device-check.js
 */
(function($){
	'use strict';
	var common = require('../_common/_common');
	var Common = new common();

	/**
	 * device判定
	 */
	var DeviceCheckInitialize = function() {
		$(function(){
			Common.device();
		});
	};

	module.exports = DeviceCheckInitialize;
})(jQuery);